import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=241bebf2&scoped=true"
import script from "./Spinner.vue?vue&type=script&lang=ts"
export * from "./Spinner.vue?vue&type=script&lang=ts"
import style0 from "./Spinner.vue?vue&type=style&index=0&id=241bebf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241bebf2",
  null
  
)

export default component.exports